import { pushPwaPartnerActivityEvent } from './gtm';

/**
 * Opens a partner entry/tracking link. Same-window navigation uses a transient anchor
 * click so mobile Safari still follows the redirect after async API calls in click handlers.
 */
export function openEntryLink(entryLink: string, openInNewTab = false): void {
  pushPwaPartnerActivityEvent('entry_link');

  if (openInNewTab) {
    const newTab = window.open(entryLink, '_blank', 'noopener,noreferrer');

    if (newTab) {
      newTab.focus();
      return;
    }
  }

  const link = document.createElement('a');
  link.href = entryLink;
  link.target = openInNewTab ? '_blank' : '_self';
  link.rel = 'noopener noreferrer';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
}
